import setBuilder from '../../../../../../Template/config/components/selection/SetBuilder'
import setBuilderToolbar from './setBuilderToolbar'


export default  {
    ...setBuilder,
    setBuilderToolbar
}


// WEBPACK FOOTER //
// ./src/app/configuration/Demo/InvestorServices/config/components/selection/SetBuilder/index.js